<template>
  <div>
    <b-button
      title="Extents"
      variant="outline-dark"
      @click="getExtents()"
      class="menu-bg-blue-transparent"
    >
      <fa :icon="['fas', 'globe']" size="lg" />
    </b-button>

    <b-modal
      id="selectExtent"
      size="md"
      content-class="menu-bg-blue-transparent-modal"
      centered
      hide-header
      hide-footer
    >
      <b-container>
        <b-row align-h="center" align-v="center">
          <b-col cols="6">
            <h4 class="center">Extents:</h4>
          </b-col>
          <b-col cols="6" align-h="center" align-v="center">
            <b-row v-for="e in extents" :key="e.id" :value="e">
              <b-button class="mb-2" variant="success" @click="changeExtent(e)">
                {{ e.extent_description }}
              </b-button>
            </b-row>
          </b-col>
        </b-row>
      </b-container>
    </b-modal>
  </div>
</template>

<script>
import {get as projGet, transformExtent} from 'ol/proj'
import View from 'ol/View'
import axios from 'axios'
export default {
  name: 'MMP_Extents',
  data() {
    return {
      extents: []
    }
  },
  props: ['user'],
  methods: {
    getExtents() {
      if (sessionStorage.token) {
        axios
          .get(process.env.API_LOCATION + '/api/users/getExtents', {
            headers: {
              'x-auth-token': sessionStorage.token
            },
            params: {
              company_id: this.user.org
            }
          })
          .then(response => {
            const content = response.data
            if (content.errors) {
              console.log('getExtents API Call Error: ' + content.errors) // added specific name to error message
            } else {
              this.extents = content
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
      this.$bvModal.show('selectExtent')
    },
    changeExtent(selectedExtent) {
      let extentValues = []
      let extentCenter = []
      /* Need to convert the string into array of numbers for passing
      to the transformExtent function. */
      selectedExtent.extent.split(',').forEach(element => {
        extentValues.push(element)
      })
      selectedExtent.extent_center.split(',').forEach(element => {
        extentCenter.push(element)
      })
      let coord = new transformExtent(
        extentValues,
        new projGet('EPSG:4326'),
        new projGet('EPSG:3857')
      )
      let view = new View({
        extent: coord,
        center: extentCenter,
        constrainOnlyCenter: true,
        zoom: 5,
        minZoom: 3,
        multiWorld: true
      })
      this.$emit('extentChanged', {
        selectedExtent: selectedExtent.extent_description,
        view: view
      })
    }
  }
}
</script>
